import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: 'input[type="time"][matInput]',
    standalone: false
})
export class NativeTimePickerDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('click')
  onClick() {
    try {
      this.el.nativeElement.showPicker();
    } catch {
      // showPicker() not supported or input not visible
    }
  }
}
